import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RiCheckboxCircleFill } from 'react-icons/ri'
import { Button, LibraryComponentType, Text, theme } from 'yolda-web-ui'
import { StyledPickupSuccess } from './PickupSuccess.style'

interface PickupSuccessProps extends LibraryComponentType {
  onAction?: () => void
}

const PickupSuccess: FC<PickupSuccessProps> = ({ onAction, onClose }) => {
  const { t } = useTranslation()

  const onClick = () => {
    onAction?.()
    onClose?.()
  }

  return (
    <StyledPickupSuccess>
      <div>
        <RiCheckboxCircleFill size={64} />
      </div>
      <Text as="h1" fontSize="large" fontWeight="normal" mb={theme.spacing.large} mt={theme.spacing.medium}>
        {`${t('trip.pickupSuccessModal.title')}`}
      </Text>
      <Text as="p" fontSize="medium" mb={theme.spacing.large}>
        {`${t('trip.pickupSuccessModal.desc1')}`}
      </Text>
      <Button onClick={onClick}>{`${t('button.ok')}`}</Button>
    </StyledPickupSuccess>
  )
}

PickupSuccess.defaultProps = {
  onAction: () => null,
}

export default PickupSuccess
